import React, { useState } from 'react';
import MIcon from './MIcon';

/**
 * Campo "en copia" compacto: por defecto es solo un enlace pequeño
 * ("+ Añadir en copia"). Al pulsarlo, despliega un input de una línea.
 * Si ya tiene contenido (ej. al editar un ticket existente), arranca
 * ya desplegado.
 *
 * <WatcherEmailsField value={form.watcher_emails} onChange={v => set('watcher_emails', v)} />
 */
export default function WatcherEmailsField({ value, onChange, compact }) {
  const [open, setOpen] = useState(!!value);

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)}
        style={{
          background:'none', border:'none', cursor:'pointer', padding:0,
          fontSize:12, color:'var(--fd-accent, var(--una-blue))', fontWeight:600,
          display:'flex', alignItems:'center', gap:4,
        }}>
        <MIcon name="add" size={14}/> Añadir en copia
      </button>
    );
  }

  return (
    <div>
      <label style={{fontSize:11,color:'var(--fd-muted,#6B7280)',display:'block',marginBottom:4}}>
        En copia (opcional, separados por coma)
      </label>
      <div style={{display:'flex',gap:6,alignItems:'center'}}>
        <input
          autoFocus
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="otro@uneatlantico.es, mas@uneatlantico.es"
          style={{
            flex:1, height:34, padding:'0 10px', border:'1px solid var(--fd-border,#E5E7EB)',
            borderRadius:'var(--radius-sm,7px)', fontSize:12.5, outline:'none', boxSizing:'border-box',
          }}
        />
        {!value && (
          <button type="button" onClick={() => setOpen(false)}
            style={{background:'none',border:'none',cursor:'pointer',color:'#9CA3AF',fontSize:16,lineHeight:1,padding:'0 4px'}}
            title="Cancelar">
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
